import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faWhatsapp} from '@fortawesome/free-brands-svg-icons'; // Correct import for social media icons
import { faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'; // Keep solid icons for email and location

function Footer() {
  return (
    <footer className="App-footer">
      <div className="footer-container">
        {/* Left Section - More Section (Additional Links) */}
        <div className="footer-section">
          <h4 className="footer-header">Explore Website:</h4>
          <ul className="footer-links">
            <li><Link to="/" className="footer-link">Home</Link></li>
            <li><Link to="/services" className="footer-link">Services</Link></li>
            <li><Link to="/about" className="footer-link">About</Link></li>
            <li><Link to="/blog" className="footer-link">Blog</Link></li>
            <li><Link to="/contact" className="footer-link">Contact</Link></li>
          </ul>
        </div>

        {/* Center Section - Contact Information */}
        <div className="footer-section">
          <h4 className="footer-header">Contact:</h4>
          <div className="footer-contact">
            <div className="footer-contact-item">
              <FontAwesomeIcon icon={faEnvelope} className="footer-icon" />
              <a href="mailto:wholisticnursingcareltd@gmail.com" className="footer-contact-link"> Hello@wholistic.co.ke</a>
            </div>
            <div className="footer-contact-item">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="footer-icon" />
              <p className="footer-location"> Assi centre, school lane westlands </p>
            </div>
          </div>
        </div>

        {/* Right Section - Social Media Icons */}
        <div className="footer-section">
          {/* <h4 className="footer-header">Follow Us:</h4> */}
          <div className="footer-social-media">
            <div className="social-icons">
            <a href="https://www.instagram.com/wholistic_homebased_care/" target="_blank" rel="noopener noreferrer" className="social-link">
                <FontAwesomeIcon icon={faInstagram} size="2x" />
              </a>
              <a href="https://wa.me/254707378979" target="_blank" rel="noopener noreferrer" className="social-link">
                <FontAwesomeIcon icon={faWhatsapp} size="2x" />
              </a>
              <a href="https://www.facebook.com/people/Wholistic-Home-based-Care/100042957324550/" target="_blank" rel="noopener noreferrer" className="social-link">
                <FontAwesomeIcon icon={faFacebook} size="2x" />
              </a>  
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="footer-bottom">
        <div className="footer-built-by">
          <p>
            Built by{" "}
            <a
              href="https://lornaombati.netlify.app/"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Lorna Ombati
            </a>
          </p>
        </div>

        {/* Copyright Section */}
        <div className="footer-copyright">
          <p>&copy; {new Date().getFullYear()} Wholistic Home-Based Care. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
